module.exports = __webpack_public_path__ + "img/1.d68d4800.webp";